// Shared heading size tokens, reused across CMS blocks so sizing stays consistent.
// The CMS is expected to provide a size value of: 'headingLarge', 'headingMedium' or 'headingSmall'.
// Each block decides which tier is its default (and can remap tiers) via the options below.

export const HEADING_SIZES = {
  large: 'text-3xl sm:text-4xl lg:text-5xl',
  medium: 'text-3lg sm:text-3xl lg:text-4xl',
  small: 'text-1xl sm:text-2xl lg:text-3xl'
}

// Accepts 'headingLarge', 'large', 'Large' etc. and reduces it to a tier key.
const normaliseSize = (value) =>
  String(value || '').replace(/^heading/i, '').toLowerCase()

/**
 * Resolve Tailwind heading classes from a CMS-provided size value.
 *
 * @param {string} cmsValue - Value from the CMS, e.g. 'headingLarge'
 * @param {object} [options]
 * @param {('large'|'medium'|'small')} [options.fallback='large'] - Tier used when cmsValue is missing or unknown
 * @param {Record<string, ('large'|'medium'|'small')>} [options.map] - Per-block remap of a CMS value to a tier
 * @returns {string} Tailwind class string for the resolved tier
 */
export const getHeadingClasses = (cmsValue, { fallback = 'large', map } = {}) => {
  const tier = (map && map[cmsValue]) || normaliseSize(cmsValue)
  return HEADING_SIZES[tier] || HEADING_SIZES[fallback]
}
